import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/about/banner.jpg';
import _imports_1 from '@/assets/img/about/banner_h5.jpg';
import _imports_2 from '@/assets/img/about/fzls.jpg';
import _imports_3 from '@/assets/img/about/hzqy.jpg';
import _imports_4 from '@/assets/img/about/hzqy-750.jpg';
import _imports_5 from '@/assets/img/about/bt.jpg';
import _imports_6 from '@/assets/img/about/bt-750.jpg';
const _withScopeId = n => (_pushScopeId("data-v-e7bd5bac"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "about"
};
const _hoisted_2 = {
  class: "top"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "banner hidden-xs-only",
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "banner hidden-sm-and-up",
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_5 = {
  class: "ctx"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "以客户为中心，用可信赖的供应链服务持续创造价值", -1));
const _hoisted_7 = {
  class: "menu"
};
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"text-intro\" data-v-e7bd5bac><span class=\"sub-title\" data-v-e7bd5bac>京奇数据</span><p class=\"text\" data-v-e7bd5bac> 四川京奇数据科技有限公司是一家专注于大数据科技领域的创新型企业，主创团队自2003年起便扎根成都， 历经多年深耕，已逐步将业务布局拓展至全国。公司凭借在地产、互联网、电子产品制造供应链等领域的 大数据沉淀，形成了独特的竞争优势。展开房产智悦拎包、新居团购礼包、京小电节能、京东服务+推广四 个板块核心业务。 </p></div><div class=\"development\" data-v-e7bd5bac><img src=\"" + _imports_2 + "\" alt=\"发展历程\" class=\"banner\" data-v-e7bd5bac></div>", 2);
const _hoisted_10 = {
  class: "text-intro culture"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "sub-title"
}, "核心业务", -1));
const _hoisted_12 = {
  class: "culture-list"
};
const _hoisted_13 = ["src", "alt"];
const _hoisted_14 = {
  class: "title"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-intro hzqj"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "hidden-xs-only",
  src: _imports_3
}), /*#__PURE__*/_createElementVNode("img", {
  class: "hidden-sm-and-up",
  src: _imports_4
})], -1));
import { useRouter } from "vue-router";
const __default__ = {
  metaInfo: {
    title: "首页-京奇数据智慧营销",
    meta: [{
      name: "description",
      content: "四川京奇数据科技有限公司是一家专注于大数据科技领域的创新型企业，提供房产智悦拎包、新居团购礼包、京小电智慧节能及京东服务+推广等核心业务。凭借强大的供应链整合能力和大数据技术，为房地产、家居和节能领域提供全方位解决方案，助力客户实现高效、节能、智能化的生活方式"
    }, {
      name: "keywords",
      content: "大数据科技、房产智悦拎包、新居团购礼包、京小电智慧节能、京东服务+推广、房地产营销、智能家居、节能解决方案、供应链整合、大数据应用、房产礼包、智慧照明、节能改造、一站式家居服务"
    }],
    link: [{
      rel: "",
      href: ""
    }]
  }
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Home',
  setup(__props) {
    const router = useRouter();
    const list = [{
      year: "2003年-2013年",
      slogan: "初创与奠基",
      develop: ["创始人团队在成都成立，开始深耕地产、互联网和电子产品制造供应链等领域。", "通过多年的积累，团队逐步形成了独特的大数据沉淀和行业洞察力。"]
    }, {
      year: "2014年至今",
      slogan: "快速发展",
      develop: ["2014年，公司正式成立，开始在西南地区拓展业务，并与万达、保利、蓝润\n" + "等品牌开发商建立了战略合作关系。此后，公司交易额逐年攀升，与多家\n" + "行业巨头形成了深度战略合作，目前，公司已发展成为集房产智悦拎包、\n" + "京小电节能项目、京东服务+推广等核心业务于一体的综合性大数据科\n" + "技公司。"]
    }];
    const culture = [{
      imgPath: require("@/assets/img/about/jzg.png"),
      title: "AI拓客",
      intro: ["AI赋能获客无忧 房产礼包助力转化", "轻松悦享高品质入住"]
    }, {
      imgPath: require("@/assets/img/about/sm.png"),
      title: "新居团购礼包",
      intro: ["新居团购礼包 一键轻松拥有", "全方位解决入住颂恼"]
    }, {
      imgPath: require("@/assets/img/about/sm.png"),
      title: "智悦节能业务",
      intro: ["智悦节能 智慧节能新选择", "让每一度电都发光发热 共创绿色未来"]
    }, {
      imgPath: require("@/assets/img/about/yj.png"),
      title: "京东服务＋推广",
      intro: ["携手京奇 体验京东服务+的卓越品质", "让每一次服务都成为生活的加分项"]
    }];
    const toUrl = name => {
      router.push({
        name: name
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _hoisted_4, _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = $event => toUrl('marketing'))
      }, "AI拓客"), _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = $event => toUrl('package'))
      }, "智悦拎包"), _createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = $event => toUrl('energy'))
      }, "智悦节能"), _createElementVNode("div", {
        onClick: _cache[3] || (_cache[3] = $event => toUrl('partner'))
      }, "合伙人招募")]), _createElementVNode("div", {
        class: "btn",
        onClick: _cache[4] || (_cache[4] = $event => toUrl('login'))
      }, " 预约咨询 ")])]), _hoisted_8, _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", _hoisted_12, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(culture, item => {
        return _createElementVNode("div", {
          key: item,
          class: "culture-item"
        }, [_createElementVNode("img", {
          src: item.imgPath,
          alt: item.title,
          class: "culture-img"
        }, null, 8, _hoisted_13), _createElementVNode("span", _hoisted_14, _toDisplayString(item.title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.intro, text => {
          return _openBlock(), _createElementBlock("div", {
            key: text,
            class: "intro-text"
          }, _toDisplayString(text), 1);
        }), 128))]);
      }), 64))])]), _hoisted_15, _createElementVNode("img", {
        class: "hidden-xs-only",
        src: _imports_5,
        style: {
          "width": "100%",
          "cursor": "pointer"
        },
        onClick: _cache[5] || (_cache[5] = $event => toUrl('login'))
      }), _createElementVNode("img", {
        class: "hidden-sm-and-up",
        src: _imports_6,
        style: {
          "width": "100%",
          "cursor": "pointer"
        },
        onClick: _cache[6] || (_cache[6] = $event => toUrl('login'))
      })]);
    };
  }
});